module.exports = __webpack_public_path__ + "img/ring_y_e_0_0.a821c32b.png";